import React from 'react';
import { FaEdit } from 'react-icons/fa';

const EditIconButton = ({ onClick, title = "Edit" }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: '#007bff',
      fontSize: '18px',
      padding: '8px',
      borderRadius: '4px'
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = '#f8f9fa';
      e.target.style.color = '#0056b3';
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = 'transparent';
      e.target.style.color = '#007bff';
    }}
  >
    <FaEdit />
  </button>
);

export default EditIconButton; 